export default __webpack_public_path__ + "images/LZ.8934c61.png";